"use strict";

const utilModule = require("js/util");
const PHX_VIEW_MARKER = "[data-phx-view]";
const CARD_MENU_MARKER = ".hover-menu";

// aka: get cards at click position
module.exports.getCard = function (event) {
    const elements = document.elementsFromPoint(event.clientX, event.clientY);

    if (elements.find((e) => e.matches(".relation-dragger")) != null) {
        return null;
    } else if (elements.find((e) => e.matches("#menu-wrapper")) != null) {
        return null;
    } else if (elements.find((e) => e.matches("#hover-menu-relation")) != null) {
        return null;
    } else {
        const card = elements.find((e) => e.matches(".view-card"));

        if (card != null) {
            return card;
        }
    }
    return null;
};

module.exports.getTriangleAtPosition = function (event) {
    const elements = document.elementsFromPoint(event.clientX, event.clientY);

    const triangles = elements.find((e) => e.matches(".link-triangle"));

    if (triangles != null) {
        return triangles;
    }
    return null;
};

const getAllCards = function (viewArea) {
    let allViewCards = viewArea.querySelectorAll(".view-card");
    return Array.from(allViewCards);
};

module.exports.getAllCards = getAllCards;

const getAllSubviewCards = function (viewArea) {
    let allSubViews = viewArea.querySelectorAll(".sub-view");
    return Array.from(allSubViews).map((each) => {
        return utilModule.findParentWithSelector(each, ".view-card");
    });
};

module.exports.getAllSubviewCards = getAllSubviewCards;

const hasAnElementFullyInside = (outerElement, allSubviews) => {
    for (const item of allSubviews) {
        let containsFully = utilModule.fullyContains(
            outerElement.getBoundingClientRect(),
            item.getBoundingClientRect(),
        );
        let isNotSameCard = outerElement.dataset.id != item.dataset.id;
        if (containsFully && isNotSameCard) {
            return true;
        }
    }
    return false;
};

module.exports.getIntersectingView = function (viewArea, dragTarget) {
    // dragged card is not inside a subview
    let subviewCards = getAllSubviewCards(viewArea);
    let intersectingSubview = subviewCards.filter((each) => {
        let intersectsThisSubview = utilModule.fullyContains(
            each.getBoundingClientRect(),
            dragTarget.getBoundingClientRect(),
        );
        let isNotSameCard = each.dataset.id != dragTarget.dataset.id;
        return intersectsThisSubview && isNotSameCard;
    });

    // card is in more than one subviews,
    if (intersectingSubview.length > 0) {
        console.log("Multiple intersecting subviews", intersectingSubview);

        /**
         * Imagine the following case
         * card A is inside subview X
         * subview X is inside Y (fully).
         * We want A to be contained only inside X, not X and Y.
         * Here we filter out all subviews which are again contained in another one
         * (we filter out the outer-subview)
         */

        let previousIntersectingSubview = intersectingSubview;

        /**
         * Let me explain this:
         * The problem is, that I want from the set of over-lapping subviews only the ones
         * which are "on top". In order to check filter them out, I check for each element
         * if it has an element fully covered. In that case that gets removed.
         */
        while (true) {
            let current = previousIntersectingSubview.filter((each) => {
                return !hasAnElementFullyInside(each, previousIntersectingSubview);
            });

            // we did not filter out anything
            if (previousIntersectingSubview.length === current.length) {
                return current;
            }
            previousIntersectingSubview = current;
        }
    } else {
        return [];
    }
};

function removePopup() {
    if (window.ldc.viewPopup != null) {
        console.log("Remove popups");
        document.body.removeChild(window.ldc.viewPopup);
        window.ldc.viewPopup = null;
        window.ldc.viewPopupOriginalParent = null;
    }
}
module.exports.removePopup = removePopup;
